import { Normalization } from '~/utils/normalization'

/**
 * The store-slug shape the API itself enforces: `['required', 'string', 'max:255',
 * 'regex:/^[a-z0-9-]+$/']` on every public store request (`PublicStoreShowRequest`,
 * `PublicStoreMenusRequest`, `PublicSameBrandStoresRequest`).
 */
const STORE_SLUG_PATTERN = /^[a-z0-9-]+$/
const STORE_SLUG_MAX_LENGTH = 255

/**
 * Guard a store slug read from sessionStorage before it is interpolated into a
 * `navigateTo` path (e.g. `/checkout/${slug}`).
 *
 * This is an allowlist, not a `/`-rejecting denylist: a single-segment check still
 * admits `?`, `#`, `\`, and percent-encoded traversal (`%2f`, `%2e%2e`), so a tampered
 * value could inject query or fragment state into the checkout route. Only the shape the
 * API accepts passes.
 */
export const isSafeStoreSlug = (slug: string | null | undefined): slug is string => {
  if (slug === null || slug === undefined || slug.length === 0) return false
  if (!Normalization.satisfiesMaxLength(slug, STORE_SLUG_MAX_LENGTH)) return false
  return Normalization.checkPattern(slug, STORE_SLUG_PATTERN)
}
